// The real login is the Supabase Auth session (see Entry.tsx); the database
// identifies the caller from that, never from anything stored here. This is
// only a local copy of who is signed in (email, name, role) so the session
// bar and routing have it synchronously. App.tsx drops it whenever the
// Supabase session is gone.
const SESSION_KEY = "tk.session";

export type Session = { email: string; firstName?: string; lastName?: string; role?: "admin" | "user" };

export function saveSession(
  email: string,
  firstName?: string | null,
  lastName?: string | null,
  role?: "admin" | "user" | null
) {
  try {
    const session: Session = { email };
    if (firstName) session.firstName = firstName;
    if (lastName) session.lastName = lastName;
    if (role) session.role = role;
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  } catch {}
}

export function getSession(): Session | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    return raw ? (JSON.parse(raw) as Session) : null;
  } catch {
    return null;
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch {}
}
